import React from 'react';
import PriceDetailsField from './PriceDetailsField';

export default function CommissionField(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,react/no-unused-prop-types
  props: { label: string, sortName?: string, dataKey?: string },
) {
  return (
    <PriceDetailsField
      {...props}
      fieldName="Commission Received"
    />
  );
}
